"use client";

import { useState, useEffect } from "react";
import { useRouter } from "next/navigation";
import enMessages from "../../messages/en.json";

export function useLanguageChange() {
  const [locale, setLocale] = useState(() =>
    typeof window !== "undefined"
      ? localStorage.getItem("locale") || "en"
      : "en"
  );
  const [messages, setMessages] = useState<Record<string, any>>(enMessages);
  const router = useRouter();

  useEffect(() => {
    const loadMessages = async () => {
      const messages = await import(`../../messages/${locale}.json`);
      setMessages(messages.default);
    };
    loadMessages();
  }, [locale]);

  const switchLanguage = (newLocale: string) => {
    localStorage.setItem("locale", newLocale);
    setLocale(newLocale);
    router.refresh();
  };

  return { locale, messages, switchLanguage };
}
